import React, { Component, PropTypes } from 'react';
import { HoverColor } from '../../../widgets/index';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

class MobilePreview extends Component {
    render() {
        const fontSize = new CSSLength(this.props.userBar.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        return (
            <div className="MobilePreview">
                <HoverColor
                    color={this.props.userBar.color.hover}
                    secondaryColor={this.props.userBar.iconColor.hover}
                    textDecoration={this.props.userBar.textDecoration.hover}
                />
                <div
                    className="row header-bar-preview"
                    style={{
                        fontFamily: this.props.userBar.font,
                        textAlign: 'center',
                        // lineHeight: this.props.preview.primaryText.lineHeight,
                        textDecoration: this.props.userBar.textDecoration.normal,
                        textTransform: this.props.userBar.textTransform,
                        // fontStyle: this.props.preview.primaryText.style,
                        color: this.props.userBar.color.normal,
                        fontWeight: this.props.userBar.fontWeight,
                        fontSize: fontSize3,
                        background: this.props.userBar.background
                    }}
                >
                    {/* <div className="col-xs-1  active-hover">
                        Rooms
                    </div>
                    <div className="col-xs-1 active-hover">
                        Add-Ons
                    </div>
                    <div className="col-xs-2 active-hover">
                        Reservations
                    </div>
                    <div className="col-xs-2">
                        <span className="spark-icon-phone spark-icon--md active-hover-secondary"
                              style={{color: this.props.userBar.iconColor.normal}}> </span><span className=" active-hover">555-555-5555</span>
                    </div> */}
                    <div
                        className=" spark-icon-menu-hamburger"
                        style={{
                            width: this.props.hamburgerMenu.width,
                            fontSize: this.props.hamburgerMenu.iconSize,
                            background: this.props.hamburgerMenu.background.normal,
                            color: this.props.hamburgerMenu.color.normal
                        }}
                    ></div>
                    <div className="col-lg-6" />
                    <div className="col-xs-2 col-lg-2">
                        <span className="col-lg-2" style={{ color: this.props.userBar.iconColor.normal }}>
                            {' '}
                        </span>{' '}
                        <span className=" active-hover"></span>
                        <span className="col-lg-1" />
                        <span className="col-lg-2" style={{ color: this.props.userBar.iconColor.normal }}>
                            {' '}
                        </span>{' '}
                        <span className=" active-hover"></span>
                        <span className="col-lg-1" />
                        <span
                            className="spark-icon-user spark-icon--md active-hover-secondary"
                            style={{ color: this.props.userBar.iconColor.normal }}
                        >
                            {' '}
                        </span>
                        <span className=" active-hover">SIGN IN</span>
                    </div>
                </div>
            </div>
        );
    }
}

MobilePreview.propTypes = {
    children: PropTypes.element,
    availableFonts: PropTypes.array,
    availableFontSizes: PropTypes.array,
    availableFontWeights: PropTypes.object,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

const mapMobilePreviewStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.header,
        ...state.theme.header
    };
};

export default connect(mapMobilePreviewStateToProps)(MobilePreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/MobilePreview.js